import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const emailApiUrl = `${baseApiUrl}/api/EmailList`;

export async function getEmailList(search) {
    return await httpRequest(fetchEmailList.bind(this, search));
}

async function fetchEmailList(search) {
    let config = getHttpHeaders();
    let url = emailApiUrl;
    if (search && search.name !== undefined) {
        url = `${url}?name=${search.name}`
    }
    if (search && search.email !== undefined) {
        url = `${url}?email=${search.email}`
    }
    return await axios.get(`${url}`, config);
}

export async function getEmailById(id) {
    return await httpRequest(fetchEmailById.bind(this, id));
}

async function fetchEmailById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${emailApiUrl}/${id}`, config);
}

export async function updateEmail(email) {
    return await httpRequest(putEmail.bind(this, email));
}

async function putEmail(email) {
    let config = getHttpHeaders();
    return await axios.put(`${emailApiUrl}`, email, config);
}

export async function addEmail(newEmail) {
    return await httpRequest(postEmail.bind(this, newEmail));
}

async function postEmail(newEmail) {
    let config = getHttpHeaders();
    return await axios.post(`${emailApiUrl}`, newEmail, config);
}

export async function deleteEmail(id) {
    return await httpRequest(fetchDeleteEmail.bind(this, id));
}

async function fetchDeleteEmail(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${emailApiUrl}/${id}`, config);
}
